import _isFunction from "lodash/isFunction";
import _kebabCase from "lodash/kebabCase";
import _isString from "lodash/isString";
import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { concatStrings } from '../utils';
import { tabContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var Tab = function Tab(props) {
  var label = props.label,
      active = props.active,
      onClick = props.onClick,
      uuid = props.uuid,
      hasRoutes = props.hasRoutes,
      url = props.url;

  var handleClick = function handleClick() {
    return onClick(label);
  };

  return hasRoutes ? ___EmotionJSX(NavLink, _extends({
    role: "tab",
    css: tabContainer(props),
    to: url,
    className: "tabs-list-item"
  }, _isFunction(onClick) && {
    onClick: handleClick
  }, _isString(uuid) && {
    'data-id': "tab-".concat(_kebabCase(uuid))
  }), label) : ___EmotionJSX("div", _extends({
    role: "tab",
    css: tabContainer(props),
    className: concatStrings('tabs-list-item', active && 'active')
  }, _isFunction(onClick) && {
    onClick: handleClick
  }, _isString(uuid) && {
    'data-id': "tab-".concat(_kebabCase(uuid))
  }), label);
};

Tab.propTypes = {
  label: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  uuid: PropTypes.string,
  hasRoutes: PropTypes.bool,
  url: PropTypes.string,
  pills: PropTypes.bool,
  vertical: PropTypes.bool
};
export default Tab;